import {
  BrowserRouter as Router,
  Routes,
  Route,
  } from 'react-router-dom';
  import Private from './pages/Private';
  import KnowYourCustomer from './pages/KnowYourCustomer';
  import Login from './pages/Login';
  import Cases from './pages/Cases';
import './App.css';

function App() {
  return (
    <Router>
		<Routes>
			<Route path="/" element={
        <Private>
          <Cases/>
        </Private>
      }/>
			<Route path="/login" element={<Login/>} />
      <Route path="/knowyourcustomer/:id" element={
        <Private>
          <KnowYourCustomer />
        </Private>
			} />
		</Routes>
	</Router>
  );
}

export default App;
